//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Annexe_VH } from 'src/app/Interfaces/Libraries/Library-FIN-int/Annexe_VH.interface';



@Component({
    selector: 'app-version-hannexe-fin',
    templateUrl: './version-hannexe-fin.component.html',
    styleUrls: ['./version-hannexe-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/VersionHAnnexeGraficGlobal.scss'],
    standalone: false
})
export class VersionHAnnexeFINComponent implements OnInit {

  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons = [
    { Icon: 'fa-file-lines', Description: 'El anexo es una nueva carga.', Status: 1 },
    { Icon: 'fa-file-lines', Description: 'El anexo fue actualizado, es decir, se actualizó sobre la versión anterior.', Status: 2 },
    { Icon: 'fa-file-lines', Description: 'El anexo no fue actualizado, pero hubo una actualización del Proceso.', Status: 3 },
    { Icon: 'fa-file-lines', Description: 'El anexo fue eliminado después de una actualización de un Proceso.', Status: 4 },
    { Icon: 'fa-file-lines', Description: 'El anexo fue eliminado después de una actualización de anexos.', Status: 5 },
  ];

  //+================== VARIABLES FOR KEYS SNAPSHOTS ==================+\\
  private ID_Annexe: number = 0;


  //+================== VARIABLE FOR ALL VERSION FIN ==================+\\
  public List_History_Annexe: Annexe_VH[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //-========================= SERVICES =========================-\\
  private Service_FIN = inject(LibraryFINService);
  private activatedRouter = inject(ActivatedRoute);

  constructor() {
    this.ID_Annexe = this.activatedRouter.snapshot.params['idA'];
  }

  ngOnInit(): void {
    this.Load_Component_VH();
  }
  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_VH(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResVersionHistory: Response_FIN = await firstValueFrom(this.Service_FIN.Get_VersionH_Annexe_FIN({ ID_Annexe: this.ID_Annexe }));

      if (ResVersionHistory.success) {
        this.List_History_Annexe = ResVersionHistory.operation;

      }

      Loader.classList.remove('active');

    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar el historial de versiones del Proceso, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTION FOR DATE FORMAT ==================-\\
  public Date_Format(Date_Created: Date): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }
  //-================== FUNCTION FOR OPEN OR CLOSE MODAL HELP ==================-\\
  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


}
